(() => {
  if (customElements.get('flaay-grid-video')) return;
  const pageReady = document.readyState === 'complete' ? Promise.resolve() : new Promise(resolve => window.addEventListener('load', resolve, { once: true }));
  class GridVideo extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.video.muted = true;
      this.manualPause = false;
      this.visible = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.button.addEventListener('click', () => {
        if (!this.video.paused) { this.manualPause = true; this.video.pause(); }
        else { this.manualPause = false; this.play(); }
      }, { signal });
      this.video.addEventListener('playing', () => {
        this.setAttribute('data-ready', '');
        this.setButton(true);
      }, { signal });
      this.video.addEventListener('pause', () => this.setButton(false), { signal });
      this.video.addEventListener('error', () => {
        this.querySelector('[role="status"]').textContent = 'Video unavailable. Tap Play to retry.';
        this.removeAttribute('data-ready');
        this.setButton(false);
      }, { signal });
      document.addEventListener('visibilitychange', () => this.sync(), { signal });
      this.motion.addEventListener('change', () => this.sync(), { signal });
      pageReady.then(() => {
        if (signal.aborted || !this.isConnected || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.15;
          this.sync();
        }, { threshold: [0, 0.15], rootMargin: '0px' });
        this.observer.observe(this);
      });
    }
    sync() {
      if (!this.visible || document.hidden || this.motion.matches || navigator.connection?.saveData) {
        this.video.pause(); return;
      }
      if (this.dataset.autoplay === 'true' && !this.manualPause) this.play();
    }
    play() {
      this.querySelector('[role="status"]').textContent = '';
      if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src;
      if (this.video.error) this.video.load();
      this.video.play().catch(() => this.setButton(false));
    }
    setButton(playing) {
      this.button.textContent = playing ? 'Pause' : 'Play';
      this.button.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} ${this.button.dataset.label}`);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.video?.pause();
    }
  }
  customElements.define('flaay-grid-video', GridVideo);
})();
